// routes
import React, { useEffect } from 'react';
import Router from './routes';
// theme
import ThemeProvider from './theme';
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
// components
import {ChartStyle} from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import {ProgressBarStyle} from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import {useSelector} from "./redux/store";
import DisablePasteGlobally from "./utils/DisablePasteGlobally";
import { useT } from '@transifex/react';
import ReactGA from "react-ga4";
import { processEnv } from './env';
// ----------------------------------------------------------------------

const MEASUREMENT_ID = processEnv.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID;
ReactGA.initialize(MEASUREMENT_ID);

export default function App() {
    const { loader } = useSelector((state) => state.common);
    const t = useT();
    useEffect(() => {
        if(document.getElementsByClassName("MuiBox-root css-fwi0lb").length > 0) { // loader css fix
            const height = document.getElementById('root').offsetHeight + "px"
            document.getElementsByClassName("MuiBox-root css-fwi0lb")[0].style.height = height
        }
    }, [])
    return (
        <MotionLazyContainer>
            <ThemeProvider>
                <NotistackProvider>
                    <LoadingOverlay
                        active={loader}
                        spinner
                        text={t('Loading...')}
                    >
                        <ProgressBarStyle/>
                        <ChartStyle/>
                        <ScrollToTop/>
                        <DisablePasteGlobally />
                        <Router/>
                    </LoadingOverlay>
                </NotistackProvider>
            </ThemeProvider>
        </MotionLazyContainer>
    );
}

// Amplify.configure(awsconfig);
//
// function App() {
//   const [user, setUser] = useState(null);
//
//   useEffect(() => {
//     Hub.listen('auth', ({ payload: { event, data } }) => {
//       switch (event) {
//         case 'signIn':
//         case 'cognitoHostedUI':
//           getUser().then(userData => setUser(userData));
//           break;
//         case 'signOut':
//           setUser(null);
//           break;
//         case 'signIn_failure':
//         case 'cognitoHostedUI_failure':
//           console.log('Sign in failure', data);
//           break;
//       }
//     });
//
//     getUser().then(userData => setUser(userData));
//   }, []);
//
//   function getUser() {
//     return Auth.currentAuthenticatedUser()
//         .then(userData => userData)
//         .catch(() => console.log('Not signed in'));
//   }
//
//   return (
//       <div>
//         <p>User: {user ? JSON.stringify(user.attributes) : 'None'}</p>
//         {user ? (
//             <button onClick={() => Auth.signOut()}>Sign Out</button>
//         ) : (
//             <button onClick={() => Auth.federatedSignIn({provider: CognitoHostedUIIdentityProvider.Google })}>Federated Sign In</button>
//         )}
//       </div>
//   );
// }
//
// export default App;
